/* esm.sh - applesauce-common@5.2.0/dist/helpers/mute */
export * from "/*applesauce-common@5.2.0/esnext/dist/helpers/mute.mjs";
